<template>
    <div>
        <page-title>应用授权信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form" label-position="top">
                <el-form-item label="授权站点" prop="host_id">
                    <el-select style="width: 100%" v-model="form.host_id" :disabled="!is_add"
                               filterable
                               remote
                               reserve-keyword
                               :loading="searchData.hostsLoading"
                               placeholder="请输入关键词"
                               :remote-method="searchHost">
                        <el-option
                                v-for="item in searchData.hosts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            <span style="float: left">{{ item.name }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.domain }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择应用">
                    <el-tag class="tag" v-if="form.display_name">
                        {{form.display_name}}
                    </el-tag>
                    <el-button @click="searchApps()" round size="mini" class="search">选择应用</el-button>
                </el-form-item>
                <el-form-item label="店铺数量(填写-1表示不限制应用数量)" prop="shop_num">
                    <el-input v-model="form.shop_num"/>
                </el-form-item>
                <el-form-item label="授权凭证" prop="new_icon">
                    <app-upload v-model="form.certificate_url" :preview="true"></app-upload>
                </el-form-item>
                <el-form-item label="备注" prop="mark">
                    <el-input v-model="form.mark"/>
                </el-form-item>
                <el-form-item label="有效期" prop="time">
                    <el-date-picker
                            :disabled="form.is_forever"
                            v-model="form.time"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            end-placeholder="结束日期">
                    </el-date-picker>
                    <div>
                        <el-checkbox v-model="form.is_forever">无限制</el-checkbox>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加'}}
                    </el-button>
                </el-form-item>
            </el-form>

            <el-dialog title="选择应用" :visible.sync="showAppsDialog" :close-on-click-modal="false">
                <el-checkbox-group v-model="searchData.apps">
                    <el-table border :data="searchData.apps" style="width: 100%;" header-row-class-name="header-class">
                        <el-table-column label="选择">
                            <template slot-scope="scope">
                                <el-radio v-model="app_id" :label="scope.row.id">&nbsp;</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="pic_url" label="logo">
                            <template slot-scope="scope">
                                <img :src="scope.row.pic_url" style="width: 46px;height: 46px"/>
                            </template>
                        </el-table-column>
                        <el-table-column prop="display_name" label="应用名称"></el-table-column>
                    </el-table>
                </el-checkbox-group>
                <div style="margin-top: 20px;" flex="dir:right cross:center">
                    <el-button type="primary" round size="mini" @click="choseApp()" class="chose">确定</el-button>
                    <el-button round size="mini" @click="showAppsDialog = false" class="cancel">取消</el-button>
                </div>
            </el-dialog>
        </page-body>
    </div>
</template>

<style scoped>
    @media screen and (max-width: 767px) {
        .cell div {
            display: block !important;
        }

        .cell div div {
            margin-left: 0 !important;
            text-align: center;
        }
    }
    .chose {
        width: 60px;
        height: 32px;
        background: #409EFF;
        border-radius: 16px;
    }
    .cancel {
        width: 60px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 16px;
        border: 1px solid #DCDFE6;
        margin-right: 15px;
    }
    .tag {
        height: 32px;
        background: #EEF6FF;
        border-radius: 16px;
        border: 1px solid #D9ECFF;
        margin-right:10px;
    }
    .search {
        height: 32px;
        border-radius: 16px;
        border: 1px solid #DCDFE6;
    }
</style>

<script>
import axios from '@/axios'
export default {
    data() {
        return {
            is_add: true,
            showAppsDialog: false,
            loading: false,
            btnLoading: false,
            app_id: null,
            form: {
                host_id: null,
                shop_num: null,
                time: [],
                app_id: null,
                display_name: null,
                is_forever: false,
                certificate_url: '',
                mark: ''
            },
            rules: {
                host_id: [
                    {required: true}
                ],
                shop_num: [
                    {required: true}
                ],
                app_id: [
                    {required: true}
                ]
            },
            searchData: {
                hostsLoading: false,
                hosts: [],
                appLoading: false,
                apps: []
            }
        }
    },
    created() {
        this.searchHost()
        if (this.$route.query.id) {
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/app-order/detail',
                params: {
                    id: this.$route.query.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.is_add = false
                    this.form = e.data.data
                    if (e.data.data.begin_time == null || e.data.data.end_time == null) {
                        this.$set(this.form, 'time', null)
                    } else {
                        this.$set(this.form, 'time', [e.data.data.begin_time, e.data.data.end_time])
                    }
                    this.form.display_name = e.data.data.app.display_name
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        searchHost(keyword) {
            this.searchData.hostsLoading = true
            axios({
                url: 'admin/host/index',
                params: {
                    keyword: keyword,
                    status: 1
                }
            }).then(e => {
                this.searchData.hostsLoading = false
                if (e.data.code === 0) {
                    this.searchData.hosts = e.data.data.list
                } else {
                    this.searchData.hosts = []
                }
            }).catch(e => {
                this.searchData.hosts = []
            })
        },
        searchApps(keyword) {
            this.app_id = this.form.app_id
            this.showAppsDialog = true
            this.searchData.appLoading = true
            axios({
                url: 'admin/app/index',
                params: {
                    keyword: keyword
                }
            }).then(e => {
                this.searchData.appLoading = false
                if (e.data.code === 0) {
                    this.searchData.apps = e.data.data.list
                } else {
                    this.searchData.apps = []
                }
            }).catch(e => {
                this.searchData.apps = []
            })
        },
        choseApp() {
            this.searchData.apps.forEach((item) => {
                if (item.id === this.app_id) {
                    this.form.display_name = item.display_name
                }
            })
            this.form.app_id = this.app_id
            this.showAppsDialog = false
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let url
                    if (this.is_add) {
                        url = 'admin/app-order/create'
                    } else {
                        url = 'admin/app-order/update'
                    }
                    this.btnLoading = true
                    this.form.begin_time = this.form.time && this.form.time[0] ? this.form.time[0] : null
                    this.form.end_time = this.form.time && this.form.time[1] ? this.form.time[1] : null
                    axios({
                        url: url,
                        params: {
                            id: this.form.id
                        },
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.replace('/dashboard/admin/app-order/index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>
